module.exports = __webpack_public_path__ + "img/13.6ce404c6.svg";